var React = require('react');

function IconView (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.84 12.948c-1.574 1.424-3.248 2.177-4.84 2.177-1.592 0-3.266-.753-4.84-2.177A13.213 13.213 0 0 1 4.4 11c.3-.41.91-1.18 1.758-1.948.31-.28.625-.527.94-.755a4.126 4.126 0 1 0 8.025 1.335c.001-.468-.08-.915-.224-1.335.316.228.63.475.94.755a13.248 13.248 0 0 1 1.759 1.949c-.3.41-.91 1.18-1.758 1.947zm-5.709-4.553a1.032 1.032 0 1 1-2.063 0 1.032 1.032 0 0 1 2.063 0zm6.632-.362C14.932 6.375 12.94 5.5 11 5.5s-3.932.875-5.763 2.533A13.91 13.91 0 0 0 3.625 9.77a2 2 0 0 0 .003 2.468c.505.639 1.04 1.215 1.609 1.73C7.068 15.624 9.06 16.5 11 16.5s3.932-.875 5.763-2.533a13.906 13.906 0 0 0 1.607-1.73 2 2 0 0 0 0-2.473 13.842 13.842 0 0 0-1.607-1.731z","fillRule":"evenodd"}));
}

IconView.defaultProps = {"viewBox":"0 0 22 22"};

module.exports = IconView;

IconView.default = IconView;
